import { useState } from 'react'

const useDownloadFile = ({
  url,
  fileNameWithExtension
}: {
  url: string
  fileNameWithExtension: string
}) => {
  const [downloadLoading, setDownloadLoading] = useState(false)

  const downloadFile = async () => {
    setDownloadLoading(true)
    try {
      const data = await fetch(url)
      const blob = await data.blob()
      const objectUrl = URL.createObjectURL(blob)

      const link = document.createElement('a')

      link.setAttribute('href', objectUrl)
      link.setAttribute('download', fileNameWithExtension)
      link.style.display = 'none'

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
    } catch (error) {
      console.error(error)
    }
    setDownloadLoading(false)
  }

  return { downloadLoading, downloadFile }
}

export default useDownloadFile
